import { useKnockFeed as u, useTranslations as i } from "@knocklabs/react-core";
import * as t from "react";
import { CheckmarkCircle as k } from "../../../core/components/Icons/CheckmarkCircle.mjs";
/* empty css            */
const C = ({
  onClick: a
}) => {
  const {
    useFeedStore: r,
    feedClient: n,
    colorMode: s
  } = u(), {
    t: l
  } = i(), o = r((e) => e.items.filter((c) => !c.read_at)), m = r((e) => e.metadata.unread_count), d = t.useCallback((e) => {
    n.markAllAsRead(), a && a(e, o);
  }, [n, o, a]);
  return /* @__PURE__ */ t.createElement("button", { className: `rnf-mark-all-as-read rnf-mark-all-as-read--${s}`, disabled: m === 0, onClick: d, type: "button" }, l("markAllAsRead"), /* @__PURE__ */ t.createElement(k, null));
};
export {
  C as MarkAsRead
};
//# sourceMappingURL=MarkAsRead.mjs.map
